import artifact from '$houdini/artifacts/UpdateRegisteredCar'
import { MutationStore } from '../runtime/stores/mutation'

export class UpdateRegisteredCarStore extends MutationStore {
	constructor() {
		super({
			artifact,
		})
	}
}
